// Ajax cart JS for Drawer and Cart Page
const drawerSelectors = {
  cartIcons: document.querySelectorAll('.header__icon--cart'),
  cartIconDesktop: document.querySelector('#cart-icon-desktop'),
  cartIconMobile: document.querySelector('#cart-icon-mobile'),
  cartCloseBtn: document.querySelector('.close-ajax--cart'),
  cartTotal: document.querySelector('#ajax-cart [data-cart-total]'),
  cartTotalDiscount: document.querySelector('#ajax-cart [data-cart-total-discount]'),

};

const removeShippingProtectionEvent = new CustomEvent('removeShippingProtection', {
  detail: {
    message: 'Event removeShippingProtection triggered manually',
    isManuallyChanged: false
  }
});

const autoAddShippingProtectionEvent = new CustomEvent('autoAdd', {
  detail: {
    message: 'Event autoAddShippingProtectionEvent triggered manually',
    time: new Date(),
  }
});
class AjaxCart extends HTMLElement {
  constructor() {
    super();

    this.openeBy = drawerSelectors.cartIcons;
    this.isOpen = this.classList.contains('open--drawer');
    this.cartForm = this.querySelector('form');
    this.sectionID = 'component-cart-drawer';

    if (window.globalVariables.template == 'cart') {
      this.style.visibility = 'visible';
      this.sectionID = 'template-cart';
    } else {
      this.addAccessibilityAttributes(this.openeBy);
    }
    this.getCartData();
    this.cart_token();

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    this.verified = false;

    // Check for visible California content and block checkout if found
    this._checkCaliforniaRestriction();
  }

  connectedCallback() {
    this.bindEvents();
    this.cartNoteInput();

    let open_cart = window.location.href.includes('open_cart=true') || window.location.href.includes('_tbn_ad');
    if (open_cart) {
      this.openCartDrawer();
    }

    document.addEventListener('octane.quiz.addToCart', () => {
      this.getCartData('open_drawer');
    })
  }

  /**
   * Observe attribute of component
   * 
   * @returns {array} Attributes to Observe
   */
  static get observedAttributes() {
    return ['updating'];
  }

  cart_token() {

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart.token) {
          this.UpdateCartToken(cart.token);
        }

      })
  }


  UpdateCartToken(cart_token) {
    let body = JSON.stringify({
      attributes: {
        '_cart_token': cart_token
      }
    });
    fetch(`${routes.cart_update_url}`, {
      ...fetchConfig(), ...{ body }
    }).then(function (data) {

    }).catch(function (error) {
      console.error('Request failed', error);

    });

  }
  /**
   * To Perform operation when attribute is changed
   * Calls attributeChangedCallback() with params when attribute value is updated
   * 
   * @param {string} name attribute name
   * @param {string} oldValue attribute Old value
   * @param {string} newValue attribute latest value
   */
  attributeChangedCallback(name, _oldValue, newValue) {
    // called when one of attributes listed above is modified
    if (name === 'updating' && newValue === 'false') {
      this.updateEvents();
    }
  }

  /**
   * Add accessibility attributes to Open Drawer buttons
   * 
   * @param {Node Array} openDrawerButtons Cart Icons
   */
  addAccessibilityAttributes(openDrawerButtons) {
    let _this = this;
    openDrawerButtons.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', _this.id);
    });
  }

  /**
   * Escape Click event to close drawer when focused within Cart Drawer
   *
   * @param {event} Event instance
   */
  onKeyUp(event) {
    if (event.code && event.code.toUpperCase() !== 'ESCAPE') return;
    drawerSelectors.cartCloseBtn.dispatchEvent(new Event('click'));
  }

  /**
   * bind dclick and keyup event to Cart Icons
   * bind keyUp event to Cart drawer component
   * bind Other inside element events
   *
   */
  bindEvents() {
    if (window.globalVariables.template !== 'cart') {
      this.openeBy.forEach(cartBtn => cartBtn.addEventListener('click', this.openCartDrawer.bind(this)));
      this.addEventListener('keyup', this.onKeyUp.bind(this));
      drawerSelectors.cartCloseBtn.addEventListener('click', this.closeCartDrawer.bind(this));
    }
    this.updateEvents();
  }
  _manageAgeVerificationCheckbox() {
    const checkbox = this.querySelector('#age-confirm');
    const checkoutButton = this.querySelector('[data-custom-checkout]');
    if (!checkbox) return;

    // Handle checkbox changes
    checkbox?.addEventListener('input', (event) => {
        this.verified = event.target?.checked;
        this._updateCheckboxStyles(checkbox);

        // Add or remove href attribute based on checkbox state
        if (checkoutButton) {
            if (event.target?.checked) {
                checkoutButton.setAttribute('href', '/checkout');
            } else {
                checkoutButton.removeAttribute('href');
            }
        }
    });

    // Set initial state if verified
    if (this.verified) {
        checkbox.checked = true;
        this._updateCheckboxStyles(checkbox);
        if (checkoutButton) {
            checkoutButton.setAttribute('href', '/checkout');
        }
    } else {
        if (checkoutButton) {
            checkoutButton.removeAttribute('href');
        }
    }

    // Handle checkout: only block default when age not confirmed (href is absent)
    checkoutButton?.addEventListener('click', (event) => {
        if (!checkbox || !checkbox.checked) {
            event.preventDefault();
            this._updateCheckboxStyles(checkbox, false);
            const wrap = checkbox?.closest('.cart-age-confirm') || checkbox?.closest('[data-age-confirm]');
            wrap?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            requestAnimationFrame(() => checkbox?.focus());
            return;
        }
    });
  }

  // Helper method to update checkbox styles
  _updateCheckboxStyles(checkbox, isValid = true) {
    const container = checkbox?.closest('[data-age-confirm]');
    if (container) {
      if (isValid) {
        container.classList.remove('border-danger', 'age-confirm--needs-attention');
        container.classList.add('border-primary-100');
        checkbox?.removeAttribute('aria-invalid');
      } else {
        container.classList.add('border-danger', 'age-confirm--needs-attention');
        container.classList.remove('border-primary-100');
        checkbox?.setAttribute('aria-invalid', 'true');
      }
    }
  }


  /**
   * bind Other inside element events to DOM
   *
   */
  updateEvents() {
    this.querySelectorAll('[data-item-remove]').forEach(button => button.addEventListener('click', this.removeItem.bind(this)));
    this.querySelectorAll('[data-qty-btn]').forEach(button => button.addEventListener('click', this.manageQtyBtn.bind(this)));
    this.querySelectorAll('[data-qty-input]').forEach(button => button.addEventListener('change', this.onQtyChange.bind(this)));
    this._manageAgeVerificationCheckbox();
    this.removeShippinProte = this.querySelector('[data-shipping-protactions-remove]');
    if (typeof (this.removeShippinProte) != 'undefined' && this.removeShippinProte != null) {
      this.removeShippinProte_key = this.removeShippinProte.getAttribute('data-shipping-protactions-remove');
      this.updateItemQty(this.removeShippinProte_key, 0);
    }
    this.updateShippinQTY = this.querySelector('[data-shipping-protactions-qtyupdate]');
    if (typeof (this.updateShippinQTY) != 'undefined' && this.updateShippinQTY != null) {
      this.removeShippinProte_key = this.updateShippinQTY.getAttribute('data-shipping-protactions-qtyupdate');
      this.updateItemQty(this.removeShippinProte_key, 1);
    }

    if (window.globalVariables.cart.item_count == 1) {
      this.updateShippinItem = this.querySelector('[data-shipping-protactions-item]');
      if (typeof (this.updateShippinItem) != 'undefined' && this.updateShippinItem != null) {
        this.removeShippinProte_key = this.updateShippinItem.getAttribute('data-shipping-protactions-item');
        this.updateItemQty(this.removeShippinProte_key, 0);
      }
    }

    // Bind subscription dropdown events
    this.bindSubscriptionDropdowns();
  }

  /**
   * Open Cart drawer and add focus to drawer container
   *
   * @param {event} Event instance
   */
  openCartDrawer(event) {
    if (!window.globalVariables.cart_drawer) {
      window.location.href = window.routes.cart_fetch_url || '/cart';
      return;
    }

    const mobileMenuDrawer = document.querySelector('#mobile-menu-drawer');
    if (mobileMenuDrawer && mobileMenuDrawer.classList.contains('opened-drawer')) {
      document.querySelector('.close-mobile--navbar')?.dispatchEvent(new Event('click'));
    }

    this.classList.add('opened-drawer');
    document.querySelector('body').classList.remove('Mega_menu');
    siteOverlay.prototype.showOverlay();
    Utility.forceFocus(this.querySelector('.cart-title'));
    Utility.trapFocus(this, drawerSelectors.cartCloseBtn);

    if (event) {
      event.preventDefault();
      let openBy = event.currentTarget;
      openBy.setAttribute('aria-expanded', true);
    }
  }

  /**
   * Close Cart drawer and Remove focus from drawer container
   *
   * @param {event} Event instance
   */
  closeCartDrawer(event, elementToFocus = false) {
    if (event == undefined) return;

    event.preventDefault();
    this.classList.remove('opened-drawer');
    siteOverlay.prototype.hideOverlay();

    let openByEle = event.currentTarget;
    openByEle.setAttribute('aria-expanded', false);
    Utility.removeTrapFocus(elementToFocus);

    let actionBtn = drawerSelectors.cartIconDesktop;
    if (window.innerWidth < 1024) {
      actionBtn = drawerSelectors.cartIconMobile;
    }
    Utility.forceFocus(actionBtn);

    setTimeout(() => {
      localStorage_state = localStorage.getItem('user_location')?.toLowerCase();
      if (!localStorage_state) {
        document.querySelector('.state-dropdown .default')?.click();
        _forceSelectProvince(true)
      }
    }, 500);
  }

  /**
   * Update cart HTML and Trigger Open Drawer event
   *
   * @param {string} cartHTML String formatted response from fetch cart.js call
   * @param {string} action Open Drawer as value if need to Open Cart drawer
   */
  _updateCart(response, action) {
    if (response === null || response == undefined) return;

    this.setAttribute('updating', true);

    // Convert the HTML string into a document object
    let cartHTML = response[this.sectionID];
    let parser = new DOMParser();
    cartHTML = parser.parseFromString(cartHTML, 'text/html');

    let cartJSONEle = cartHTML.querySelector('[data-cartScriptJSON]');
    window.globalVariables.cart = JSON.parse(cartJSONEle.textContent);

    let cartElement = cartHTML.querySelector('.cart-form-container');
    this.querySelector('.cart-form-container').innerHTML = cartElement.innerHTML;

    let shippingpProtection = cartHTML.querySelector('[data-shipping-protection]');
    shippingpProtection && (this.querySelector('[data-shipping-protection]').innerHTML = shippingpProtection.innerHTML);

    let cartTotal = Utility.formatMoney(window.globalVariables.cart.total_price, window.globalVariables.money_format);
    drawerSelectors.cartTotal.innerHTML = cartTotal;

    if (drawerSelectors.cartTotalDiscount) {
      let cartTotalDiscount = Utility.formatMoney(window.globalVariables.cart.total_discount, window.globalVariables.money_format);
      drawerSelectors.cartTotalDiscount.innerHTML = cartTotalDiscount;

      if (window.globalVariables.cart.total_discount <= 0) {
        drawerSelectors.cartTotalDiscount?.closest('.total-discount-price')?.classList.add('d-none');
      } else {
        drawerSelectors.cartTotalDiscount?.closest('.total-discount-price')?.classList.remove('d-none');
      }
    }

    let cart_items_count = cartHTML.querySelector('[data-item-count]');
    if (cart_items_count) this.querySelector('[data-item-count]').innerHTML = cart_items_count.innerHTML;

    let elements = this.querySelectorAll('[data-checkoutBtns], [data-cartnote]');
    let cart_container = this.querySelector('.cart-form-container');
    if (window.globalVariables.cart.item_count <= 0) {
      elements.forEach((div) => {
        div.classList.add('d-none');
      });
      cart_container.classList.add('empty_cart');
    } else {
      elements.forEach((div) => {
        div.classList.remove('d-none');
      });
      cart_container.classList.remove('empty_cart');
    }

    this.setAttribute('updating', false);

    let headerHTML = new DOMParser().parseFromString(response['header'], 'text/html');
    let cartIcon = headerHTML.getElementById('cart-icon-desktop');
    if (drawerSelectors.cartIconDesktop) drawerSelectors.cartIconDesktop.innerHTML = cartIcon.innerHTML;
    if (drawerSelectors.cartIconMobile) drawerSelectors.cartIconMobile.innerHTML = cartIcon.innerHTML;

    if (window.globalVariables.cart.items.length >= 1) {

      let packageProtectionIndex = window.globalVariables.cart.items.findIndex((item) => {
        return item.properties['_shipping_protection'] == true;
      });

      const protectionWidget = this.querySelector('[data-shipping-protection] shipping-protection');
      const isWidgetVisible = protectionWidget && !protectionWidget.closest('.d-none');

      if (isWidgetVisible && (window.globalVariables.cart.attributes['_shipping_protection'] == undefined || window.globalVariables.cart.attributes['_shipping_protection'] == 'N/A') && packageProtectionIndex == -1) {
        document.dispatchEvent(autoAddShippingProtectionEvent);
      }

      if ((!isWidgetVisible || window.globalVariables.cart.items.length == 1) && packageProtectionIndex > -1) {
        document.dispatchEvent(removeShippingProtectionEvent);
      }
    } else {
      let attributes = { '_shipping_protection': "N/A" };
      ShippingProtection.prototype._updateCartAttributes(attributes)
    }

    Utility.updateMotivationBar();
    if (window.globalVariables.template !== 'cart' && window.globalVariables.cart_drawer && action === 'open_drawer') {
      this.openCartDrawer();
    }
    // Utility.handleCartSync();

    // Check for visible California content and block checkout if found
    this._checkCaliforniaRestriction();
  }

  /**
   * Check if any cart item has visible California content and block checkout
   */
  _checkCaliforniaRestriction() {
    const cartItems = document.querySelectorAll('[data-cart-item]');
    let hasVisibleCaliforniaContent = false;

    cartItems.forEach(cartItem => {
      const californiaContent = cartItem.querySelector('[data-california-content]');
      if (californiaContent && Utility.isVisible(californiaContent)) {
        hasVisibleCaliforniaContent = true;
      }
    });

    const checkoutButtons = document.querySelectorAll('[data-checkout-button-container], [data-age-confirm]');
    checkoutButtons.forEach(checkoutButton => {
      if (hasVisibleCaliforniaContent) {
        checkoutButton.setAttribute('disabled', 'disabled');
        checkoutButton.classList.add('disabled', 'opacity-5');
      } else {
        checkoutButton.removeAttribute('disabled');
        checkoutButton.classList.remove('disabled', 'opacity-5');
      }
    });
  }

  /**
   * Fetch latest cart data 
   *
   * @param {string} action Open Drawer as value if need to Open Cart drawer or else let it be empty
   */
  getCartData(action) {
    let cartRoute = `${window.location.pathname}?sections=${this.sectionID},header`;
    fetch(cartRoute).then(response => {
      return response.json();
    }).then(response => {
      this._updateCart(response, action);
    }).catch((e) => {
      console.error(e);
    }).finally(() => {
      // Cart HTML fetch done
    });
  }

  /**
  * Update Quantity API call 
  *
  * @param {string} line Line Index value of cart Item (Starts from 1)
  * @param {integer} quantity Quantity to update
  */
  updateItemQty(line, quantity) {
    let lineItem = document.querySelector(`[data-cart-item="${line}"]`);

    if (lineItem) { lineItem.classList.add('updating'); }
    var body = {};
    body[line] = quantity;
    body = JSON.stringify({
      updates: body,
      sections: `${this.sectionID},header`
    });
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ... { body } })
      .then((response) => {
        return response.text();
      })
      .then((_state) => {
        let dataJSON = ((typeof res == 'object') ? _state : JSON.parse(_state));
        if (dataJSON.errors) {
          console.error(dataJSON.errors)
        }
        this._updateCart(dataJSON.sections);
      }).catch((error) => {
        console.error(error, 'error')
      }).finally(() => {
        setTimeout(() => {
          if (lineItem) { lineItem.classList.remove('updating'); }
        }, 500);
      });
  }

  /**
   * Remove Item Event
   *
   * @param {event} Event instance
   */
  removeItem(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let itemIndex = currentTarget.dataset.index || null;
    if (itemIndex === null) return;

    const cartItems = window.globalVariables?.cart?.items || [];
    const removedItem = cartItems.find((i) => i.key === itemIndex);

    if (removedItem?.properties?._bundle_id && removedItem?.properties?._bundle_parent) {
      const bundleId = removedItem.properties._bundle_id;
      const updates = {};
      cartItems.forEach((i) => {
        if (i.properties?._bundle_id === bundleId) {
          updates[i.key] = 0;
        }
      });
      this.removeBundleItems(updates);
    } else {
      this.updateItemQty(itemIndex, 0);
    }
  }

  removeBundleItems(updates) {
    const body = JSON.stringify({
      updates,
      sections: `${this.sectionID},header`,
    });
    this.setAttribute('updating', true);
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body })
      .then((response) => response.text())
      .then((_state) => {
        const dataJSON = typeof _state === 'object' ? _state : JSON.parse(_state);
        if (dataJSON.errors) console.error(dataJSON.errors);
        this._updateCart(dataJSON.sections);
      })
      .catch((error) => console.error(error))
      .finally(() => this.setAttribute('updating', false));
  }

  /**
   * Cart Item Qunatity Increment/Decrement Button event
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || 'increase';
    let $qtyInput = currentTarget.closest('[data-qty-container]')?.querySelector('[data-qty-input]');
    if (!$qtyInput) return;
    let itemIndex = $qtyInput.dataset.index || 1;

    let stepQty = ($qtyInput.step) ? parseInt($qtyInput.step) : 1;
    let minQty = ($qtyInput.min) ? parseInt($qtyInput.min) : 1;
    let maxQty = ($qtyInput.max) ? parseInt($qtyInput.max) : null;

    let currentQty = parseInt($qtyInput.value) || minQty;
    let finalQty = currentQty;

    if (action === 'decrease' && currentQty <= minQty) {
      return false;
    } else if (action === 'decrease') {
      finalQty = currentQty - stepQty;
    } else {
      finalQty = currentQty + stepQty;
    }

    this.updateItemQty(itemIndex, finalQty);

    // if(maxQty != null && finalQty <= maxQty && finalQty >= minQty){
    //   this.updateItemQty(itemIndex, finalQty);
    // }else if(finalQty >= minQty){ 

    // }
  }

  /**
   * Cart Item Qunatity Input change event
   *
   * @param {event} Event instance
   */
  onQtyChange(event) {
    const $qtyInput = event.currentTarget;
    const qtyValue = $qtyInput.value;
    const itemIndex = $qtyInput.dataset.index || null;
    if (itemIndex) this.updateItemQty(itemIndex, qtyValue);
  }

  /**
   * Manage Cart Notes
   */
  cartNoteInput() {
    const cartNoteEle = document.querySelector('[data-cartNote] [name="note"]');
    if (!cartNoteEle) return;

    const cartNoteSave = document.querySelector('[data-saveNote]');
    let cartNoteEvents = ['input', 'paste'];
    cartNoteEvents.forEach((eventName) => {
      cartNoteEle.addEventListener(eventName, (evt) => {
        const defaultNote = cartNoteEle.dataset.default;
        if (defaultNote !== cartNoteEle.value) {
          cartNoteSave.style.display = 'block';
        } else {
          cartNoteSave.style.display = 'none';
        }
      }, false);
    });

    //  Cart Note Change event
    cartNoteSave.addEventListener("click", evt => {
      evt.preventDefault();
      const cartNoteContainer = evt.currentTarget.closest('[data-cartNote]');
      const cartNote = cartNoteContainer.querySelector('[name="note"]').value.trim();
      if (cartNote.length <= 0) {
        alert('Add Note before proceeding');
        return;
      }

      const submitBtn = cartNoteContainer.querySelector('[data-saveNote]');
      const waitText = (submitBtn.dataset.adding_txt) ? submitBtn.dataset.adding_txt : 'Saving...';
      submitBtn.innerHTML = waitText;
      submitBtn.disabled = true;
      this.updateCartNote(cartNoteContainer);
    });
  }

  /**
   * Update Cart Note
   * @param {element} cartNoteContainer 
   */
  updateCartNote(cartNoteContainer) {
    const _this = this;
    const cartNoteEle = cartNoteContainer.querySelector('[name="note"]');
    const cartNote = cartNoteEle.value.trim();
    const resultEle = cartNoteContainer.querySelector('[data-resultMsg]');
    const submitBtn = cartNoteContainer.querySelector('[data-saveNote]');
    const defaultText = (submitBtn.dataset.default) ? submitBtn.dataset.default : 'Save';

    let body = JSON.stringify({
      note: cartNote
    });
    fetch(`${routes.cart_update_url}`, {
      ...fetchConfig(), ...{ body }
    }).then(function (data) {
      if (data.status === 200) {
        if (resultEle) {
          resultEle.innerText = 'Added note to Order!';
          _this.manageResponseText(resultEle);
        }
        if (cartNoteEle) {
          cartNoteEle.dataset.default = cartNote;
        }
        submitBtn.style.display = 'none';
        submitBtn.innerHTML = defaultText;
        submitBtn.disabled = false;
      }
      else {
        console.error('Request returned an error', data);
        if (resultEle) {
          resultEle.innerText = data;
          _this.manageResponseText(resultEle);
        }
        submitBtn.innerHTML = defaultText;
        submitBtn.disabled = false;
      }
    }).catch(function (error) {
      console.error('Request failed', error);
      if (resultEle) {
        resultEle.innerText = error;
        _this.manageResponseText(resultEle);
      }
      submitBtn.innerHTML = defaultText;
      submitBtn.disabled = false;
    });
  }

  /**
   * fade effect on reponse
   * @param {element} element 
   */
  manageResponseText(element) {
    Utility.fadeEffect(element, 'fadeIn');
    setTimeout(() => {
      Utility.fadeEffect(element, 'fadeOut');
    }, 3000);
  }

  /**
   * Bind subscription dropdown events
   */
  bindSubscriptionDropdowns() {
    const subscriptionDropdowns = this.querySelectorAll('[data-cart-subscription-dropdown]');
    const customDropdowns = this.querySelectorAll('[data-custom-dropdown]');
    const subscribeButtons = this.querySelectorAll('[data-subscription-toggle-btn]');

    subscriptionDropdowns.forEach(dropdown => {
      dropdown.addEventListener('change', this.handleSubscriptionChange.bind(this));
    });

    // Bind custom dropdown events
    customDropdowns.forEach(dropdown => {
      this.initCustomDropdown(dropdown);
    });

    // Bind subscribe button click events (for one-time items)
    subscribeButtons.forEach(button => {
      button.addEventListener('click', this.handleSubscribeButtonClick.bind(this));
    });
  }

  /**
   * Handle subscribe button click - selects first selling plan and triggers change
   */
  handleSubscribeButtonClick(event) {
    const button = event.currentTarget;
    const widget = button.closest('[data-cart-item-subscription]');
    const hiddenSelect = widget.querySelector('[data-cart-subscription-dropdown]');
    
    if (!hiddenSelect) return;
    
    // Find first selling plan option (skip "onetime")
    const firstSellingPlanOption = Array.from(hiddenSelect.options).find(
      option => option.value !== 'onetime'
    );
    
    if (firstSellingPlanOption) {
      // Set the value to first selling plan
      hiddenSelect.value = firstSellingPlanOption.value;
      
      // Dispatch change event to trigger existing handler
      const changeEvent = new Event('change', { bubbles: true });
      hiddenSelect.dispatchEvent(changeEvent);
    }
  }

  /**
   * Initialize custom dropdown
   */
  initCustomDropdown(dropdownContainer) {
    const button = dropdownContainer.querySelector('[data-dropdown-button]');
    const menu = dropdownContainer.querySelector('[data-dropdown-menu]');
    const options = dropdownContainer.querySelectorAll('[data-dropdown-option]');
    const hiddenSelect = dropdownContainer.querySelector('[data-cart-subscription-dropdown]');
    const selectedText = button.querySelector('[data-dropdown-selected]');

    // Toggle dropdown on button click
    button.addEventListener('click', (e) => {
      e.stopPropagation();
      const isExpanded = button.getAttribute('aria-expanded') === 'true';

      // Close all other dropdowns
      this.querySelectorAll('[data-dropdown-button]').forEach(btn => {
        if (btn !== button) {
          btn.setAttribute('aria-expanded', 'false');
          btn.closest('[data-custom-dropdown]').querySelector('[data-dropdown-menu]').hidden = true;
        }
      });

      // Toggle current dropdown
      button.setAttribute('aria-expanded', !isExpanded);
      menu.hidden = isExpanded;
    });

    // Handle option selection
    options.forEach(option => {
      option.addEventListener('click', (e) => {
        e.stopPropagation();
        const value = option.dataset.value;
        const label = option.dataset.label;

        // Update selected text
        selectedText.textContent = label;

        // Update hidden select
        hiddenSelect.value = value;

        // Trigger change event on hidden select
        const changeEvent = new Event('change', { bubbles: true });
        hiddenSelect.dispatchEvent(changeEvent);

        // Update active state
        options.forEach(opt => opt.classList.remove('active'));
        option.classList.add('active');

        // Update checkmarks - clear all and add to selected
        options.forEach(opt => {
          const wrapper = opt.querySelector('.check-icon-wrapper');
          if (wrapper) wrapper.innerHTML = '';
        });

        const wrapper = option.querySelector('.check-icon-wrapper');
        if (wrapper) {
          const checkIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          checkIcon.setAttribute('width', '12');
          checkIcon.setAttribute('height', '10');
          checkIcon.setAttribute('viewBox', '0 0 16 16');
          checkIcon.setAttribute('fill', 'none');
          checkIcon.classList.add('check-icon');
          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', 'M13.3333 4L6 11.3333L2.66667 8');
          path.setAttribute('stroke', 'currentColor');
          path.setAttribute('stroke-width', '2');
          path.setAttribute('stroke-linecap', 'round');
          path.setAttribute('stroke-linejoin', 'round');
          checkIcon.appendChild(path);
          wrapper.appendChild(checkIcon);
        }

        // Close dropdown
        button.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!dropdownContainer.contains(e.target)) {
        button.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
      }
    });
  }

  /**
   * Handle subscription dropdown change
   */
  async handleSubscriptionChange(event) {
    const dropdown = event.target;
    const selectedValue = dropdown.value;
    const selectedOption = dropdown.options[dropdown.selectedIndex];
    const widget = dropdown.closest('[data-cart-item-subscription]');
    const lineKey = widget.dataset.lineKey;
    const quantity = parseInt(widget.querySelector('[data-cart-item-quantity]').value);

    // Prepare update data
    let updateData = {
      id: lineKey,
      quantity: quantity
    };

    if (selectedValue === 'onetime') {
      // Convert to one-time purchase - remove selling plan
      updateData.selling_plan = '';
    } else {
      // Set subscription with selected frequency
      const sellingPlanId = parseInt(selectedValue);
      updateData.selling_plan = sellingPlanId;
    }

    // Disable dropdown during update
    dropdown.disabled = true;
    widget.style.opacity = '0.5';

    try {
      // Update cart item
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(updateData)
      });

      if (!response.ok) {
        throw new Error(`Cart update failed: ${response.status}`);
      }

      await response.json();

      // Refresh cart
      this.getCartData();
    } catch (error) {
      console.error('Error updating cart item:', error);
      alert('Failed to update cart item. Please try again.');

      // Reload cart on error
      this.getCartData();
    } finally {
      dropdown.disabled = false;
      widget.style.opacity = '1';
    }
  }
}
customElements.define("cart-form", AjaxCart);